(function () {
  function isSingleImageParagraph(el) {
    return (
      el.tagName === "P" &&
      el.children.length === 1 &&
      el.children[0].tagName === "IMG" &&
      el.textContent.trim() === ""
    );
  }

  document.querySelectorAll(".article-template-content__rte").forEach((rte) => {
    let run = [];

    const flushRun = () => {
      if (run.length > 1) {
        const grid = document.createElement("div");
        grid.className = "rte-image-grid";
        run[0].before(grid);
        run.forEach((paragraph) => grid.appendChild(paragraph));
      }
      run = [];
    };

    Array.from(rte.children).forEach((el) => {
      if (isSingleImageParagraph(el)) {
        run.push(el);
      } else {
        flushRun();
      }
    });
    flushRun();
  });
})();
